class KPVariantSelect extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form[action*="/cart/add"]');
    this.select = this.querySelector('[data-variant-select]');
    this.price = this.querySelector('[data-product-price]');
    this.submit = this.querySelector('[data-add-to-cart]');
    this.variants = JSON.parse(this.querySelector('[data-variants-json]').textContent);
    if (this.select) this.select.addEventListener('change', () => this.onVariantChange());
  }

  onVariantChange() {
    const id = Number(this.select.value);
    const variant = this.variants.find((item) => item.id === id);
    if (!variant) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    if (this.price) this.price.textContent = this.formatMoney(variant.price);
    if (this.submit) {
      this.submit.disabled = !variant.available;
      this.submit.textContent = variant.available ? this.submit.dataset.availableText : this.submit.dataset.soldText;
    }
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'PKR',
      maximumFractionDigits: 0
    }).format(cents / 100);
  }
}

customElements.define('kp-variant-select', KPVariantSelect);

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('[data-menu-toggle]');
  if (menuButton) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = menu.hasAttribute('data-open');
    menu.toggleAttribute('data-open', !open);
    menuButton.setAttribute('aria-expanded', String(!open));
  }

  const filterButton = event.target.closest('[data-filter-toggle]');
  if (filterButton) {
    const drawer = document.querySelector('[data-filter-drawer]');
    const overlay = document.querySelector('[data-filter-overlay]');
    const open = drawer.hasAttribute('data-open');
    drawer.toggleAttribute('data-open', !open);
    overlay?.toggleAttribute('data-open', !open);
    document.documentElement.toggleAttribute('data-filter-open', !open);
    filterButton.setAttribute('aria-expanded', String(!open));
  }

  const closeFilter = event.target.closest('[data-filter-close]');
  if (closeFilter) {
    document.querySelector('[data-filter-drawer]')?.removeAttribute('data-open');
    document.querySelector('[data-filter-overlay]')?.removeAttribute('data-open');
    document.documentElement.removeAttribute('data-filter-open');
  }
});
